var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessenger = function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M23.4 0H2.6A2.6 2.6 0 0 0 .013 2.6L0 26l5.2-5.2h18.2a2.61 2.61 0 0 0 2.6-2.6V2.6A2.61 2.61 0 0 0 23.4 0M7.8 15.6H5.2V13h2.6Zm0-3.9H5.2V9.1h2.6Zm0-3.9H5.2V5.2h2.6Zm9.1 7.8h-6.5V13h6.5Zm3.9-3.9H10.4V9.1h10.4Zm0-3.9H10.4V5.2h10.4Z",
    "data-name": "Icon material-speaker-notes"
  })));
};
export default SvgMessenger;